module.exports = __webpack_public_path__ + "static/media/icon_paycard-error.6ccea58f.svg";